import { render, staticRenderFns } from "./deletePartnerGoods.vue?vue&type=template&id=126ada52"
import script from "./deletePartnerGoods.vue?vue&type=script&lang=js"
export * from "./deletePartnerGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports